import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  SimpleGrid,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import { FiHeart, FiBookOpen, FiGlobe, FiUsers } from "react-icons/fi";

const projects = [
  {
    icon: FiGlobe,
    title: "توسعه بازار سرمایه و تأمین مالی مسئولانه",
    desc: "ارتقای زیرساخت‌های بازار سرمایه و ارائه خدمات تأمین مالی با رعایت اصول حرفه‌ای",
    impact: "",
  },
  {
    icon: FiBookOpen,
    title: "شفافیت و ارتقای سواد مالی",
    desc: "تلاش در جهت افزایش شفافیت اطلاعاتی و ارتقای دانش مالی عمومی",
    impact: "",
  },
  {
    icon: FiUsers,
    title: "مسئولیت‌پذیری سازمانی و حاکمیت شرکتی",
    desc: "اجرای اصول حاکمیت شرکتی و تعهد به مسئولیت‌پذیری در تمامی سطوح سازمان",
    impact: "",
  },
  {
    icon: FiHeart,
    title: "حمایت از نوآوری و ابزارهای نوین مالی",
    desc: "توسعه ابزارهای مالی نوین و حمایت از نوآوری در بازار سرمایه",
    impact: "",
  },
];

export const SectionCSR = () => {
  const headingColor = useColorModeValue("gray.900", "white");
  const textColor = useColorModeValue("gray.600", "gray.300");
  const cardBg = useColorModeValue("gray.50", "dark.300");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const iconBg = useColorModeValue("brand.100", "icon.bg");
  const iconColor = useColorModeValue("brand.500", "icon.svg");
  const impactColor = useColorModeValue("brand.600", "brand.300");
  const impactBg = useColorModeValue("brand.50", "brand.900");

  return (
    <Box>
      <Container maxW="container.xl">
        <VStack spacing={8} align="stretch">
          <VStack spacing={3} align="center" textAlign="center">
            <Heading
              as="h2"
              fontSize={{ base: "xl", md: "2xl", lg: "3xl" }}
              fontWeight="bold"
              color={headingColor}
            >
              مسئولیت اجتماعی و پایداری
            </Heading>
            <Text
              fontSize={{ base: "sm", md: "md" }}
              color={textColor}
              maxW="600px"
            >
              تأمین سرمایه امید مسئولیت اجتماعی را بخشی از رویکرد حرفه‌ای خود در
              بازار سرمایه می‌داند و تلاش می‌کند نقشی مؤثر در توسعه پایدار،
              ارتقای شفافیت و حمایت از منافع ذی‌نفعان ایفا کند.
            </Text>
          </VStack>

          <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={4}>
            {projects.map((p) => (
              <Box
                key={p.title}
                bg={cardBg}
                borderRadius="xl"
                border="1px solid"
                borderColor={borderColor}
                p={5}
                _hover={{ shadow: "md", borderColor: "brand.200" }}
                transition="all 0.3s"
              >
                <VStack align="flex-start" spacing={2}>
                  <HStack justify="space-between" w="100%">
                    <Box bg={iconBg} p={3} borderRadius="lg">
                      <Icon
                        verticalAlign="middle"
                        as={p.icon as any}
                        boxSize={6}
                        color={iconColor}
                      />
                    </Box>
                    {p.impact && (
                      <Text
                        fontSize="xs"
                        fontWeight="bold"
                        color={impactColor}
                        bg={impactBg}
                        px={2}
                        py={0.5}
                        borderRadius="md"
                      >
                        {p.impact}
                      </Text>
                    )}
                  </HStack>
                  <Text fontWeight="bold" color={headingColor}>
                    {p.title}
                  </Text>
                  <Text color={textColor} lineHeight="1.7">
                    {p.desc}
                  </Text>
                </VStack>
              </Box>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  );
};
